<section>
  <h2>Events, NIBIN Leads, &amp; Targets</h2>
  <p-messages key="irCrimeGuns" [closable]="true"></p-messages>
  <form [formGroup]="eventsLeadsTargetsForm">
    <div class="row row-cols-md-2 g-3 align-items-start">
      <div class="col-12 mb-3 table-responsive">
        <table class="temp-bs table table-sm table-striped table-bordered ">
          <caption class="caption-top form-label text-body required-field">Primary Crime Gun ID(s)</caption>
          <thead>
            <tr>
              <th scope="col">Crime Gun ID(s)</th>
              <th scope="col">Legacy Gun ID(s)</th>
              <th scope="col"># of Linked Shootings</th>
              <th scope="col" class="w-10"><span class="visually-hidden">Delete</span></th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="ENESS_XREF_IRsCrimeGuns_Primary.controls.length == 0;else pcgrows">
              <tr><td colspan="4">No primary crime gun ID(s) found.</td></tr>
            </ng-container>
            <ng-template #pcgrows>
              <tr *ngFor="let cgn of ENESS_XREF_IRsCrimeGuns_Primary.controls; let i = index">
                <th scope="row" class="text-nowrap">{{ cgn.get('CrimeGunNumber').value }}</th>
                <td class="text-break">{{ cgn.get('ENESS_CrimeGunNumbers.LegacyATFGunNumber').value  }}</td>
                <td class="text-break">{{ cgn.get('NumberOfLinkedShootings').value }}</td>
                <td class="text-center">
                  <button type="button" title="Delete Primary Crime Gun ID" (click)="ENESS_XREF_IRsCrimeGuns_Primary.removeAt(i)" class="btn btn-sm btn-danger"><i class="fas fa-times" aria-hidden="true"></i><span class="visually-hidden">Delete Primary Crime Gun ID</span></button>
                </td>
              </tr>
            </ng-template>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="4" class="p-3">
                <div class="mb-3">
                  <label class="form-label" for="ENESS_XREF_IRsCrimeGuns_Primary">
                    Primary Crime Gun ID(s)
                  </label>
                  <p class="small">(Type first 6 digits of a crime gun ID for autocomplete search. i.e. 760-18)</p>
                  <p-autoComplete #pcgn inputId="ENESS_XREF_IRsCrimeGuns_Primary" inputStyleClass="form-control" [suggestions]="crimeGunIds" field="CrimeGunNumber" [minLength]="6" (completeMethod)="searchCrimeGunIds($event)" [tabindex]="0" appendTo="body"></p-autoComplete>
                </div>
                <button type="button" id="addPrimaryCG" class="btn btn-sm btn-success" [disabled]="!pcgn.value" (click)="onAddCrimeGun($event, pcgn)"><i class="fa fa-plus" aria-hidden="true"></i> Add Primary Crime Gun ID(s)</button>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div class="col-12 mb-3 table-responsive">
        <table class="temp-bs table table-sm table-striped table-bordered ">
          <caption class="caption-top form-label text-body required-field">Linked Crime Gun ID(s)</caption>
          <thead>
            <tr>
              <th scope="col">Crime Gun ID(s)</th>
              <th scope="col">Legacy Gun ID(s)</th>
              <th scope="col"># of Linked Shootings</th>
              <th scope="col" class="w-10"><span class="visually-hidden">Delete</span></th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="ENESS_XREF_IRsCrimeGuns_Related.controls.length == 0;else rcgrows">
              <tr><td colspan="4">No linked crime gun ID(s) found.</td></tr>
            </ng-container>
            <ng-template #rcgrows>
              <tr *ngFor="let cgn of ENESS_XREF_IRsCrimeGuns_Related.controls; let i = index">
                <th scope="row" class="text-nowrap">{{ cgn.get('CrimeGunNumber').value }}</th>
                <td class="text-break">{{ cgn.get('ENESS_CrimeGunNumbers.LegacyATFGunNumber').value }}</td>
                <td class="text-break">{{ cgn.get('NumberOfLinkedShootings').value }}</td>
                <td class="text-center"><button type="button" title="Delete Linked Crime Gun ID" (click)="ENESS_XREF_IRsCrimeGuns_Related.removeAt(i)" class="btn btn-sm btn-danger"><i class="fas fa-times" aria-hidden="true"></i><span class="visually-hidden">Delete related crime gun ID</span></button></td>
              </tr>
            </ng-template>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="4" class="p-3">
                <div class="mb-3">
                  <label class="form-label" for="ENESS_XREF_IRsCrimeGuns">
                    Linked Crime Gun ID(s)
                  </label>
                  <p class="small">(Type first 6 digits of a crime gun ID for autocomplete search. i.e. 760-18)</p>
                  <p-autoComplete #rcgn inputId="ENESS_XREF_IRsCrimeGuns" inputStyleClass="form-control" [suggestions]="crimeGunIds" field="CrimeGunNumber" [minLength]="6" (completeMethod)="searchCrimeGunIds($event)" [tabindex]="0" appendTo="body"></p-autoComplete>
                </div>
                <button type="button" id="addRelatedCG" class="btn btn-sm btn-success" [disabled]="!rcgn.value" (click)="onAddCrimeGun($event, rcgn)"><i class="fa fa-plus" aria-hidden="true"></i> Add Linked Crime Gun ID(s)</button>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
    <div class="mb-3 table-responsive">
      <table class="temp-bs table table-sm table-striped table-bordered ">
        <caption class="caption-top form-label text-body required-field">RMS Event(s)</caption>
        <thead>
          <tr>
            <th scope="col">State</th>
            <th scope="col">Agency</th>
            <th scope="col">LE Case #</th>
            <th scope="col">LE Partner</th>
            <th scope="col" class="w-10"><span class="visually-hidden">Delete</span></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="infoReportLECaseNumbers?.length == 0;else lcnrows">
            <tr><td colspan="5">No LE Case #(s) found.</td></tr>
          </ng-container>
          <ng-template #lcnrows>
            <tr *ngFor="let lecn of infoReportLECaseNumbers; let i = index">
              <th scope="row">{{lecn.StateAbbreviation}}</th>
              <td>{{ lecn.AgencyName}}</td>
              <td>{{ lecn.LECaseNumber }}</td>
              <td>{{ lecn.LEPartners }}</td>
              <td class="text-center"><button type="button" title="Delete LE case number" (click)="DeleteLECaseNumber(i, lecn.LECaseNumberID)" class="btn btn-sm btn-danger"><i class="fas fa-times" aria-hidden="true"></i><span class="visually-hidden">Delete LE case number</span></button></td>
            </tr>
          </ng-template>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="5" class="p-3">
              <div class="row row-cols-lg-auto gy-2 gx-3 align-items-start" [formGroup]="leCaseNumberForm">
                <div class="col-12">
                  <label for="StateID" class="form-label">State</label>
                  <select #state id="StateID" formControlName="StateID" class="form-select" (change)="searchAgencies(state.value)">
                    <option value="">Select a state</option>
                    <ng-container *ngIf="lookupService.usStates$ | async as usStates">
                      <option *ngFor="let state of usStates" value="{{state.StateID}}">{{state.StateName}}</option>
                    </ng-container>
                  </select>
                </div>
                <div class="col-12">
                  <label for="AgencyID" class="form-label">Agency</label>
                  <select #agency id="AgencyID" formControlName="AgencyID" class="form-select" (change)="searchCaseNumbers(agency.value)">
                    <option value="">Select an agency</option>
                    <option *ngFor="let agency of agenciesByStateId" value="{{agency.AgencyID}}">{{agency.AgencyName}}</option>
                  </select>
                </div>
                <div class="col-12">
                  <label for="LECaseNumberID" class="form-label">LE Case #</label>
                  <p-autoComplete #lcn formControlName="LECaseNumberID" [suggestions]="caseNumbersTextFiltered" (completeMethod)="filterLECaseNumberSingle($event)" field="LECaseNumber" placeholder="Select a case #" inputStyleClass="form-select" [minLength]="1" [dropdown]="true" inputId="LECaseNumberID" appendTo="body"></p-autoComplete>
                  <p class="small">(Begin typing to search)</p>
                  <div class="cross-validation-feedback" *ngIf="leCaseNumberForm.get('AgencyID').valid && caseNumbersByAgencyId.length == 0">
                    No case numbers found for selected agency.
                  </div>
                </div>
              </div>
              <button type="button" class="btn btn-sm btn-success mt-2" [disabled]="leCaseNumberForm.invalid" (click)="addSelectedLECaseNumber()"><i class="fa fa-plus" aria-hidden="true"></i> Add LE Case #</button>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
    <div>
      <h3 class="mb-3">People/Target(s)</h3>
      <p-table #ptt [value]="people" [paginator]="true" [alwaysShowPaginator]="false" responsiveLayout="scroll" [rows]="rows" styleClass="mb-3">
        <ng-template pTemplate="caption">
          <div class="p-2 fw-bold text-center">
            People/Target(s) Selection
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th scope="col" pSortableColumn="LastName">Last Name <p-sortIcon field="LastName" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon></th>
            <th scope="col" pSortableColumn="FirstName">First Name <p-sortIcon field="FirstName" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon></th>
            <th scope="col" pSortableColumn="DateOfBirth">Birth Date <p-sortIcon field="DateOfBirth" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon></th>
            <th scope="col" pSortableColumn="SSN">SSN <p-sortIcon field="SSN" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon></th>
            <th scope="col" class="w-10"><span class="visually-hidden">Remove</span></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="5">
              No people found.
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
          <tr>
            <th scope="row">
              {{rowData.ENESS_Person?.LastName}}
            </th>
            <td>
              {{rowData.ENESS_Person?.FirstName}}
            </td>
            <td>
              {{rowData.ENESS_Person?.DateOfBirth  | date:"MM/dd/yyyy" }}
            </td>
            <td>
              {{rowData.ENESS_Person?.SSN | ssnFormat}}
            </td>
            <td class="text-center">
              <button type="button" class="btn btn-sm btn-danger" (click)="removePerson(rowIndex)"><i class="fas fa-times" aria-hidden="true"></i><span class="visually-hidden">Remove person</span></button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div class="card my-3">
      <div class="card-header"><h4>Find an Existing Person</h4></div>
      <div class="card-body" [formGroup]="findAPersonForm">
        <div class="row row-cols-md-auto g-lg-3 g-md-2 align-items-start mb-3">
          <div class="col-12">
            <div class="row">
              <label for="SelectFilterType" class="required-field col-auto form-label">Filter by:</label>
              <div class="col-auto mb-2">
                <select #personFilterType class="form-select form-select-sm" id="SelectFilterType" formControlName="FilterID" required aria-required="true">
                  <option value="{{ null }}">Select person filter type</option>
                  <option *ngFor="let filter of filterTypes" value="{{filter.FilterColumnName}}">{{ filter.FilterDisplayValue }}</option>
                </select>
                <div class="invalid-feedback">Please select a filter type.</div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <ng-container *ngIf="['Name', 'DateOfBirth', 'SSN', 'PhoneNumber'].indexOf(findAPersonForm.get('FilterID').value) == -1">
              <label for="personFilterInput" class="visually-hidden">Filter text:</label>
              <input id="personFilterInput" formControlName="FilterInput" type="text" class="form-control form-control-sm mb-2" />
            </ng-container>
            <ng-container *ngIf="findAPersonForm.get('FilterID').value === 'Name'">
              <div class="row">
                <label for="FirstName" class="col-auto mb-2">First name:</label>
                <div class="col-auto mb-2"><input id="FirstName" type="text" formControlName="FilterFirstNameInput" class="form-control form-control-sm" /></div>
              </div>
              <div class="row">
                <label for="LastName" class="col-auto mb-2">Last name:</label>
                <div class="col-auto mb-2"><input id="LastName" type="text" formControlName="FilterLastNameInput" class="form-control form-control-sm" /></div>
              </div>
            </ng-container>
            <ng-container *ngIf="findAPersonForm.get('FilterID').value === 'DateOfBirth'">
              <label for="FilterDate" class="visually-hidden">Filter date</label>
              <p-calendar inputId="FilterDate" formControlName="FilterDate" [showIcon]="true" icon="far fa-calendar-alt" inputStyleClass="form-control form-control-sm mb-2" [showOnFocus]="false" [maxDate]="maxDateRule"></p-calendar>
            </ng-container>
            <ng-container *ngIf="findAPersonForm.get('FilterID').value === 'SSN'">
              <label for="FilterSSN" class="visually-hidden">Filter SSN</label>
              <p-inputMask inputId="FilterSSN" formControlName="FilterSSN" mask="999-99-9999" styleClass="form-control form-control-sm mb-2"></p-inputMask>
            </ng-container>
            <ng-container *ngIf="findAPersonForm.get('FilterID').value === 'PhoneNumber'">
              <label for="FilterPhoneNumber" class="visually-hidden">Filter Phone Number</label>
              <p-inputMask inputId="PhoneNumber" formControlName="FilterPhoneNumber" mask="(999) 999-9999" styleClass="form-control form-control-sm mb-2" [maxlength]="80" [autoClear]="false"></p-inputMask>
            </ng-container>
            <div class="cross-validation-feedback" *ngIf="!findAPersonForm.pristine && !!findAPersonForm.get('FilterID').value && !findAPersonForm.valid">
              Please enter a filter value.
            </div>
          </div>
          <div class="col-12">
            <button type="button" class="btn btn-sm btn-success mb-2" (click)="searchPerson()" [disabled]="findAPersonForm?.errors"><i class="fas fa-search" aria-hidden="true"></i> Find</button>
          </div>
        </div>
        <p-table [value]="peopleSearchResults" [columns]="peopleSearchResultTableCols" [paginator]="true" [alwaysShowPaginator]="false" responsiveLayout="scroll" [rows]="rows" selectionMode="multiple" [(selection)]="selectedPeople" dataKey="PersonID" [loading]="loading" [autoLayout]="true">
          <ng-template pTemplate="caption">
            <div class="p-2 fw-bold text-center">
              Find Existing Person Result
            </div>
          </ng-template>
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th scope="col" *ngFor="let col of columns" [pSortableColumn]="col.field">
                {{col.header}} <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
            <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex">
              <th scope="row">
                <div *ngFor="let fbiNum of rowData.ENESS_XREF_PeopleFBIFileNumbers">
                  {{fbiNum.FBIFileNumber}}
                </div>
              </th>
              <td>
                <div *ngFor="let stateId of rowData.ENESS_XREF_PeopleStateIDNumbers">
                  {{ stateId.StateAbbreviation?.concat(':')}} {{ stateId.StateIDNumbers}}
                </div>
              </td>
              <td>{{rowData.LastName}}</td>
              <td>{{rowData.FirstName}}</td>
              <td>{{rowData.DateOfBirth | date:"MM/dd/yyyy" }}</td>
              <td>{{rowData.SSN | ssnFormat}}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length">
                No person found.
              </td>
            </tr>
          </ng-template>
        </p-table>
        <button type="button" [disabled]="selectedPeople.length==0" (click)="addSelectedPerson()" class="btn btn-sm btn-success mt-3"><i class="fas fa-plus" aria-hidden="true"></i> Add selected person to targets</button>
      </div>
    </div>
  </form>
</section>
